import React from "react";
import formatWithUnits from "../utils/currencyFormat";

/**
 * Cards component - Shows top inclusions/exclusions
 * 
 * Displays:
 * - Stock name
 * - Value (in Mn) instead of quantity (no longer available)
 * - % change with color coding
 */
const Cards = ({ title, data }) => {
  return (
    <div
      style={{
        flex: 1,
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        maxWidth: "500px",
      }}
    >
      <h3 style={{ marginBottom: "20px", fontSize: "18px", color: "#333" }}>
        {title}
      </h3>
      {data.length === 0 ? (
        <p style={{ color: "#888", fontSize: "14px" }}>No data available</p>
      ) : (
        data.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "15px",
            }}
          >
            {/* Stock Name and Value */}
            <div>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#444",
                }}
              >
                {item.stockName}
              </span>
              <br />
              <span
                style={{
                  fontSize: "12px",
                  color: "#888",
                }}
              >
                {item.valueInMn ? formatWithUnits(item.valueInMn, "₹") : 
                  item.percentageOfTotalHoldings ? `${item.percentageOfTotalHoldings.toFixed(2)}%` : '-'}
              </span>
            </div>

            {/* Change */}
            <div
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: (item.oneMonthChangeInPtHoldings || 0) > 0 ? "#34A853" : "#EA4335",
              }}
            >
              {item.oneMonthChangeInPtHoldings != null
                ? item.oneMonthChangeInPtHoldings > 0
                  ? `+${item.oneMonthChangeInPtHoldings.toFixed(2)}%`
                  : `${item.oneMonthChangeInPtHoldings.toFixed(2)}%`
                : '-'}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Cards;
